import siteVars from "../utils/utils";
import {DualHRangeBar} from 'dual-range-bar';
import {moneyFormat} from "../helpers/helpers";

const s = {
    taxonomy: '[data-taxonomy]',
    productGrid: '[data-product-grid]',
    pagination: '[data-pagination-list]',
    foundPosts: '[data-found-posts]',
    bodyTaxonomy: 'body.archive',
    closeSortFilter: '[data-close-sort-filter]',
    sortFilterTrigger: '[data-sort-filter-trigger]',
    modalSort: '[data-modal-sort]',
    modalFilter: '[data-modal-filter]',
    sortOrderOption: '[data-sort-order-option]',
    filterOptionIsOnSale: '[name="filters_is_on_sale"]',
    body: 'body',
    productConfig: '[data-taxonomy-config]',
    productGridWrapper: '#product-grid',
}

const classes = {
    sortActive: 'sort-active', filterActive: 'filter-active', active: 'active', productLoading: 'product-loading'
}

export default class Taxonomy {
    constructor() {
        if (!$(s.bodyTaxonomy).length) return;
        this.previousSortBy = this.getSortBy();
        this.previousFilters = this.getFilters(this.getSearchParams());
        this.eventHandlers();
        this.ajaxProductCache(false, false, $(s.productConfig).data('update-dom') === 1, $(s.productConfig).data('append-url') === 1);
    }

    eventHandlers() {
        $(document).on('click', s.closeSortFilter, this.applySortFilter.bind(this));
        $(document).on('click', s.sortFilterTrigger, this.openSortFilter.bind(this));
        $(document).on('click', s.sortOrderOption, this.onChangeSortBy.bind(this));
        $(document).on('change', s.filterOptionIsOnSale, this.onChangeFilterOptionIsOnSale.bind(this));
    }

    initDualSliderSingle(elem, min, max, isCurrency) {
        if (elem.data('dualHRangeBarInstance')) return; // Prevent re-initialization 
        const id = elem.attr('id');
        const minActive = elem.data('min-active') && elem.data('min-active') !== '' ? elem.data('min-active') : min;
        const maxActive = elem.data('max-active') && elem.data('max-active') !== '' ? elem.data('max-active') : max;
        if (min === max) return;

        const price = new DualHRangeBar(id, {lowerBound: min, upperBound: max, lower: minActive, upper: maxActive});
        elem.data('dualHRangeBarInstance', price); // Store the instance

        const updateLabels = (lower, upper) => {
            document.getElementById(`${id}-x1`).innerText = isCurrency ? moneyFormat(lower) : `${lower}%`;
            document.getElementById(`${id}-x2`).innerText = isCurrency ? moneyFormat(upper) : `${upper}%`;
        };

        updateLabels(minActive, maxActive);

        price.addEventListener('update', (event) => {
            let lower = parseInt(event.detail.lower, 10);
            let upper = parseInt(event.detail.upper, 10);
            updateLabels(lower, upper);

            const searchParams = this.getSearchParams();
            searchParams.set(id, `${lower}-${upper}`);
            this.updateURL(this.getPaged(), this.getSortBy(), searchParams);
        });
    }

    onChangeFilterOptionIsOnSale(e) {
        e.preventDefault();
        const _this = $(e.currentTarget);
        const name = _this.attr('name');
        const url = new URL(window.location.href, window.location.origin);
        const searchParams = url.searchParams;
        if (!searchParams.has(name)) {
            searchParams.set(name, '1');
        } else {
            searchParams.delete(name);
        }

        this.updateURL(this.getPaged(), this.getSortBy(), searchParams);
    }

    getFilters(searchParams) {
        return searchParams ? Array.from(searchParams.keys()).filter(key => key.startsWith('filters_')).map(key => `${key}=${searchParams.get(key)}`).join('&') : null;
    }

    applySortFilter(e) {
        e.preventDefault();
        $('body').removeClass(classes.sortActive + ' ' + classes.filterActive);
        const currentSortBy = this.getSortBy();
        const currentFilters = this.getFilters(this.getSearchParams());

        if (currentSortBy !== this.previousSortBy || currentFilters !== this.previousFilters) {
            this.previousSortBy = currentSortBy;
            this.previousFilters = currentFilters;
            this.ajaxProductCache(1, true);
        }
    }

    onChangeSortBy(e) {
        e.preventDefault();
        const _this = $(e.currentTarget);
        $(s.sortOrderOption).removeClass(classes.active);

        this.setSortBy(_this.data('sort-order-option'));
        _this.addClass(classes.active);
    }

    openSortFilter(e) {
        e.preventDefault();
        const _this = $(e.currentTarget);
        const target = _this.data('sort-filter-trigger');
        $('body').addClass(target);
    }

    getPaged(newPage = false) {
        let page = 1;
        const url = new URL(window.location.href, window.location.origin);
        const getPaged = url.searchParams.get('page');
        if (newPage) {
            page = newPage;
        } else if (getPaged) {
            page = parseInt(getPaged, 10);
        }

        return page;
    }

    setSortBy(sortBy) {
        const href = window.location.href;
        const url = new URL(href, window.location.origin);
        url.searchParams.set('sort_by', sortBy);
        this.updateURL(this.getPaged(), sortBy);
    }

    getSortBy() {
        const url = new URL(window.location.href, window.location.origin);
        return url.searchParams.get('sort_by') ?? this.getDefaultSortBy();
    }

    getDefaultSortBy() {
        return $(s.productConfig).data('sort-by');
    }

    updateURL(page, sortBy, searchParams = null, appendURL = true) {
        const currentSearchParams = searchParams || this.getSearchParams();
        const filters = this.getFilters(currentSearchParams);
        let newUrl = '';

        if (!appendURL) {
            newUrl = null;
        } else {
            if (page) {
                newUrl = `?page=${page}`;
            }
            if (sortBy) {
                newUrl += `&sort_by=${sortBy}`;
            }
            if (filters) {
                newUrl += `&${filters}`;
            }
        }

        history.pushState({location: location.href, hash: location.hash}, '', newUrl);
    }

    getSearchParams() {
        return new URL(window.location.href, window.location.origin).searchParams;
    }

    toggleProductLoading(isLoading) {
        if (isLoading) {
            $(s.body).addClass(classes.productLoading);
        } else {
            $(s.body).removeClass(classes.productLoading);
        }
    }

    async ajaxProductCache(newPage = false, scrollToTop = true, updateProductList = true, appendURL = true) {
        const searchParams = this.getSearchParams();
        const page = this.getPaged(newPage);
        const sortBy = this.getSortBy();
        const filters = this.getFilters(searchParams);

        if (updateProductList) {
            this.toggleProductLoading(true);
        }

        if (scrollToTop) {
            location.hash = s.productGridWrapper;
        }

        const productData = await this.getJsonProductData();

        // Filter and sort the productData directly
        const filteredSortedData = this.sortProducts(this.filterProductsData(productData, filters), sortBy);

        // Update product stats and initialize sliders
        const stats = await this.calculateProductStats(productData);

        this.initDualSliderSingle($('#filters_price'), stats.min, stats.max, true);
        this.initDualSliderSingle($('#filters_discount'), 0, stats.maxDiscount, false);

        // Update the DOM with the filtered and sorted product data
        await this.updateDomProductData(filteredSortedData, page, updateProductList, appendURL);

        // Update URL
        this.updateURL(page, sortBy, searchParams, appendURL);
    }

    async calculateProductStats(productData) {
        let max = 0;
        let min = Infinity;
        let maxDiscount = 0;

        productData.forEach(product => {
            if (product.price_lowest > max) {
                max = product.price_lowest;
            }
            if (product.price_lowest > 0 && product.price_lowest < min) {
                min = product.price_lowest;
            }
            if (product.discount > maxDiscount) {
                maxDiscount = product.discount;
            }
        });

        return {
            min: parseInt(min, 10),
            max: parseInt(max, 10),
            maxDiscount: parseInt(maxDiscount, 10),
        };
    }

    updatePartnerList(productData) {
        const partnerCounts = new Map();

        productData.forEach(product => {
            if (product.partner) {
                partnerCounts.set(product.partner, (partnerCounts.get(product.partner) || 0) + 1);
            }
        });

        return Array.from(partnerCounts.entries()).map(([partner, count]) => ({partner, count}));
    }

    generatePagination(min, max, currentIndex, onClickCallback) {
        const $container = $(s.pagination);
        $container.empty();

        const paginationRange = 2; // Number of pagination items before and after current page

        let start = Math.max(min, currentIndex - paginationRange);
        let end = Math.min(max, currentIndex + paginationRange);

        // Always include first and last
        if (start > min) {
            $container.append(this.createPageButton(min, currentIndex, onClickCallback));
            if (start > min + 1) {
                $container.append('<span class="page-numbers dots">...</span>');
            }
        }

        for (let i = start; i <= end; i++) {
            $container.append(this.createPageButton(i, currentIndex, onClickCallback));
        }

        if (end < max) {
            if (end < max - 1) {
                $container.append('<span class="page-numbers dots">...</span>');
            }
            $container.append(this.createPageButton(max, currentIndex, onClickCallback));
        }
    }

    createPageButton(page, currentIndex, onClickCallback) {
        currentIndex = parseInt(currentIndex);
        const $btn = $(`<a class="page-numbers ${page === currentIndex ? ' current' : ''}">${page}</a>`);

        $btn.on('click', function () {
            onClickCallback(page);
        });

        return $btn;
    }

    filterProductsData(productData, filters) {
        const filterObject = this.splitFilters(filters);

        return productData.filter(data => {

            // Check discount filter
            if (filterObject.filters_discount) {
                const [minDiscount, maxDiscount] = filterObject.filters_discount.split('-').map(Number);
                if (data.discount < minDiscount || data.discount > maxDiscount) {
                    return false;
                }
            }

            // Check is_on_sale filter
            if (filterObject.filters_is_on_sale && (!data.discount_price || data.discount_price < 1)) {
                return false;
            }

            // Check price filter
            if (filterObject.filters_price) {
                const [minPrice, maxPrice] = filterObject.filters_price.split('-').map(Number);
                if (data.price_lowest < minPrice || data.price_lowest > maxPrice) {
                    return false;
                }
            }

            return true;
        });
    }

    splitFilters(filters) {
        const filterArray = filters.split('&');
        const filterObject = {};
        filterArray.forEach(filter => {
            const [key, value] = filter.split('=');
            if (key && value) {
                filterObject[key] = value;
            }
        });
        return filterObject;
    }

    async updateDomProductData(productData, page, updateProductList, appendURL = true) {
        const postsPerPage = siteVars.posts_per_page;
        const startIndex = (page - 1) * postsPerPage;
        const endIndex = startIndex + postsPerPage;
        const totalPages = Math.ceil(productData.length / postsPerPage);
        const uploadUrl = siteVars.wp_upload_url;
        const htmlPaths = productData.map(data => `${uploadUrl}/${data.html_path}`).slice(startIndex, endIndex);

        // Fetch HTML content for the current page
        const htmlContent = await this.getProductTeaserHTML(htmlPaths);

        // Batch DOM updates
        const $productGrid = $(s.productGrid);
        const $foundPosts = $(s.foundPosts);
        if (updateProductList) {
            $productGrid.html(htmlContent);
            if (!appendURL) {
                console.log('Updating term transient');
                this.ajaxSetTermTransient(htmlContent);
            } else {
                console.log('Not updating term transient');
            }
        } else {
            console.log('Transient exists');
        }
        $foundPosts.html(productData.length);

        // Generate pagination
        this.generatePagination(1, totalPages, page, (newPage) => {
            this.ajaxProductCache(newPage);
        });

        this.toggleProductLoading(false);
    }

    ajaxSetTermTransient(html) {
        $.ajax({
            url: siteVars.ajax_url,
            type: 'POST',
            data: {
                action: 'set_term_transient',
                term_id: siteVars.term_id,
                _wpnonce: siteVars.nonce,
                html: JSON.stringify(html), // Encode the HTML
            },
        });
    }

    async getProductTeaserHTML(htmlPaths) {
        const timestamp = new Date().getTime();
        const fetchPromises = htmlPaths.map(async (path) => {
            const urlWithTimestamp = `${path}?t=${timestamp}`;
            const response = await fetch(urlWithTimestamp);
            if (response.ok) {
                return response.text();
            } else {
                return '';
            }
        });

        const htmlContents = await Promise.all(fetchPromises);
        return htmlContents.join('');
    }

    sortProducts(productData, sortBy) {
        return productData.sort((aData, bData) => {

            switch (sortBy) {
                case 'date_desc':
                    return (bData.date ?? 0) - (aData.date ?? 0);
                case 'discount_desc':
                    return (bData.discount ?? 0) - (aData.discount ?? 0);
                case 'discount_price_desc':
                    return (bData.discount_price ?? 0) - (aData.discount_price ?? 0);
                case 'price_asc':
                    return (aData.price_lowest ?? 0) - (bData.price_lowest ?? 0);
                case 'price_desc':
                    return (bData.price_lowest ?? 0) - (aData.price_lowest ?? 0);
                default:
                    return 0;
            }
        });
    }

    async getJsonProductData() {
        const urls = siteVars.term_id_product_json_files_path;
        const fetchPromises = urls.map(url => fetch(url).then(response => {
            if (!response.ok) {
                throw new Error(`Failed to fetch data from ${url}`);
            }
            return response.json();
        }).catch(error => {
            return [];
        }));

        const results = await Promise.allSettled(fetchPromises);
        return results.filter(result => result.status === 'fulfilled').map(result => result.value).flat();
    }
}